<div id="advisory" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title mb-4">Library Advisory Committee</h2>
      </div>

      <div class="col-12 mb-4">
        <p class="inner-lead">
          The College has a library advisory Committee helps to aligning library services, resources
          and responsive to community needs, fostering trust and credibility.
        </p>
      </div>

      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-bordered table-hover align-middle">
            <thead class="table-light">
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Dr. Geeta Monga</td>
                <td>Principal</td>
                <td>Chairperson</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Dr. Monika</td>
                <td>Librarian</td>
                <td>Convener</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Dr. Rekha</td>
                <td>Asst. Prof.</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Ms. Jasbir Kaur</td>
                <td>Asst. Prof.</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Ms. Payal</td>
                <td>Asst. Prof.</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Ms. Gurdeep Kaur</td>
                <td>Asst. Prof.</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Ms. Suman</td>
                <td>Asst. Prof.</td>
                <td>Member</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
